import { createContext, useState, useContext } from 'react'

const DEFAULT_SHED_CONTENTS = {}

type ShedValue = string | object | [] | boolean

type Value = {
  shed: Record<string, ShedValue>
  updateShed: (key: string, value: ShedValue) => void
  clearShed: (key: string) => void
}

export const ShedContext = createContext<Value>(null)

export const useShed = <T extends Partial<Value>>() =>
  useContext(ShedContext) as T

type Props = {
  children?: React.ReactNode
}

export const ShedProvider: React.FC<Props> = ({ children }) => {
  const [shed, setShed] = useState(DEFAULT_SHED_CONTENTS)

  const updateShed = (key: string, value: ShedValue) => {
    const shedClone = { ...shed }
    shedClone[key] = value
    setShed(shedClone)
  }

  const clearShed = (key: string) => {
    const shedClone = { ...shed }
    delete shedClone[key]
    setShed(shedClone)
  }

  const value: Value = { updateShed, clearShed, shed }

  return <ShedContext.Provider value={value}>{children}</ShedContext.Provider>
}
